<script setup>
import { Chip } from '@dashhudson/dashing-ui/chip';
import { computed } from 'vue';

import InteractionActionMenu from '@/app/community/components/InteractionActionMenu.vue';
import SentimentSelectChip from '@/app/community/components/SentimentSelectChip.vue';
import SpamSelectChip from '@/app/community/components/SpamSelectChip.vue';
import { useCommunityPermissions } from '@/app/community/composables/useCommunityPermissions';
import {
  COMMUNITY_INTERACTION_TYPES,
  COMMUNITY_PERMISSION_TYPES,
  communitySentimentTypes,
} from '@/app/community/constants';

const props = defineProps({
  interaction: { type: Object, required: true },
  hiddenMenuItems: { type: Array, default: () => [] },
  collapsed: { type: Boolean, default: undefined },
  disabled: { type: Boolean, default: undefined },
  inPreview: { type: Boolean, default: undefined },
  location: { type: String, default: 'PANEL' },
});

const { canAccessYoutubeCompliance, verifyBrandAndUserAccess } = useCommunityPermissions();

const canAccessTextAnalysis = computed(() => {
  const complianceCheck =
    canAccessYoutubeCompliance.value ||
    props.interaction?.type !== COMMUNITY_INTERACTION_TYPES.YOUTUBE_COMMENT;
  const hasAccess = verifyBrandAndUserAccess(
    props.interaction?.brandId,
    COMMUNITY_PERMISSION_TYPES.TEXT_ANALYSIS,
  );

  return complianceCheck && hasAccess;
});
const isSentimentAccessibleType = computed(() =>
  communitySentimentTypes().includes(props.interaction?.type),
);
</script>

<template>
  <div
    data-test="InteractionUtility"
    class="dash-w-full dash-flex dash-justify-between dash-items-center"
  >
    <div>
      <div v-if="canAccessTextAnalysis" class="dash-flex dash-gap-1">
        <Chip
          v-if="interaction.responseRecommended"
          tooltip="Response Recommended"
          class="response-recommended"
          icon="response-recommended"
        />
        <Chip
          v-if="interaction.sentiment?.isQuestion && isSentimentAccessibleType"
          tooltip="Question"
          class="question"
          icon="message-question"
        />
        <SpamSelectChip
          v-if="interaction.isSpam"
          :interaction="interaction"
          :location="location"
          :disabled="disabled"
        />
        <SentimentSelectChip
          v-if="interaction.sentiment && isSentimentAccessibleType"
          :interaction="interaction"
          :hide-label="inPreview"
          :disabled="disabled"
        />
      </div>
    </div>
    <InteractionActionMenu v-if="!disabled" v-bind="props" />
  </div>
</template>
